import { Checkbox, IconButton, Menu, MenuButton, MenuList, Stack } from "@chakra-ui/react"
import _ from "lodash"
import { forwardRef, useEffect, useImperativeHandle, useState } from "react"
import { HiOutlineChevronDown, HiOutlineChevronUp } from "react-icons/hi2"
import { useGetQuery } from "../../../services/api.service"
import { customeJsonParser } from "../../../utils/utils"

const FilterPanel = forwardRef(({ width = 300, onFilter = () => { }, body = {}, api = '' }: any, ref) => {
    const [filter, setFilter]: any = useState({})

    const compiled = _.template(body);
    const compiledResult = compiled({ filter: filter });

    const { data: _data, isLoading, isFetching } = useGetQuery({
        method: api,
        body: customeJsonParser(compiledResult),
        providesTags: []
    })

    const data = _.get(_data, 'message', [])
    const dataSetLength = _.size(data)
    const stringifyFilter = JSON.stringify(filter)
    const stringifyData = JSON.stringify(data)

    useEffect(() => {
        onFilter(filter)
    }, [stringifyFilter])


    useEffect(() => {
        removeRedundantData()
    }, [stringifyData])


    const removeRedundantData = () => {
        let modifiedFilter: any = {}
        if (filter && data) data?.map((item: any) => {
            if (filter[item.value]) {
                modifiedFilter[item.value] = filter[item.value]?.filter((value: any) => item?.childrens?.some((item: any) => item.value === value.value))
            }
        })

        setFilter(modifiedFilter)
    }

    useImperativeHandle(ref, () => {
        return {
            removeFilter(key: any, index: any) {
                if (key && String(index)) {
                    let clonedFilter = _.cloneDeep(filter)
                    if (clonedFilter[key] && _.isArray(clonedFilter[key])) {
                        const updatedArray = clonedFilter[key].filter((_: any, i: any) => i !== index);
                        const updatedFilter = { ...clonedFilter, [key]: updatedArray };
                        setFilter(updatedFilter)
                    }
                }
            }
        }

    }, [stringifyFilter]);

    const checkboxMarkup = (
        <Stack paddingEnd={5}> {
            data?.map(({ label, value, selection_mode = "single", childrens }: any, index: any) => (
                <div key={index}>
                    <ParentCheckBox index={index} label={label} value={value} setFilter={setFilter} filter={filter}>
                        <Stack pl={6} mt={1} spacing={2} pb={index < (dataSetLength - 1) ? 3 : 0}>
                            {childrens?.map((item: any, index: number) => (
                                <ChildCheckBox key={index} selection_mode={selection_mode} label={item?.label} value={item?.value} parent={value} setFilter={setFilter} filter={filter} />
                            ))}
                        </Stack>
                    </ParentCheckBox>
                </div>
            ))
        }
        </Stack>
    )

    return (
        <Menu>
            <MenuButton
                as={IconButton}
                aria-label='Options'
                icon={<svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13 3.00003C13.2652 3.00003 13.5196 2.89468 13.7071 2.70714C13.8946 2.5196 14 2.26525 14 2.00003C14 1.73482 13.8946 1.48046 13.7071 1.29293C13.5196 1.10539 13.2652 1.00003 13 1.00003L5.732 1.00003C5.55646 0.696019 5.30398 0.443566 4.99996 0.268046C4.69593 0.0925252 4.35106 0.000121649 4 0.000121633C3.64894 0.000121618 3.30407 0.0925251 3.00004 0.268045C2.69602 0.443566 2.44354 0.696019 2.268 1.00003L1 1.00003C0.734783 1.00003 0.480429 1.10539 0.292892 1.29293C0.105356 1.48046 -7.5826e-08 1.73482 -8.74189e-08 2.00003C-9.90119e-08 2.26525 0.105356 2.5196 0.292892 2.70714C0.480429 2.89468 0.734783 3.00003 1 3.00003L2.268 3.00003C2.44354 3.30405 2.69602 3.5565 3.00004 3.73202C3.30407 3.90754 3.64894 3.99995 4 3.99995C4.35106 3.99995 4.69593 3.90754 4.99996 3.73202C5.30398 3.5565 5.55646 3.30405 5.732 3.00003L13 3.00003ZM13 9.00003C13.2652 9.00003 13.5196 8.89468 13.7071 8.70714C13.8946 8.5196 14 8.26525 14 8.00003C14 7.73482 13.8946 7.48046 13.7071 7.29293C13.5196 7.10539 13.2652 7.00003 13 7.00003L11.732 7.00003C11.5565 6.69602 11.304 6.44357 11 6.26805C10.6959 6.09253 10.3511 6.00012 10 6.00012C9.64894 6.00012 9.30407 6.09253 9.00004 6.26805C8.69602 6.44357 8.44354 6.69602 8.268 7.00003L1 7.00003C0.734783 7.00003 0.480428 7.10539 0.292892 7.29293C0.105356 7.48046 -3.38094e-07 7.73482 -3.49687e-07 8.00003C-3.6128e-07 8.26525 0.105356 8.5196 0.292892 8.70714C0.480428 8.89468 0.734783 9.00003 1 9.00003L8.268 9.00003C8.44354 9.30405 8.69602 9.5565 9.00004 9.73202C9.30407 9.90754 9.64894 9.99995 10 9.99995C10.3511 9.99995 10.6959 9.90754 11 9.73202C11.304 9.5565 11.5565 9.30405 11.732 9.00003L13 9.00003ZM14 14C14 14.2653 13.8946 14.5196 13.7071 14.7071C13.5196 14.8947 13.2652 15 13 15L5.732 15C5.55646 15.304 5.30398 15.5565 4.99996 15.732C4.69593 15.9075 4.35106 15.9999 4 15.9999C3.64894 15.9999 3.30407 15.9075 3.00004 15.732C2.69602 15.5565 2.44354 15.304 2.268 15L0.999999 15C0.734783 15 0.480428 14.8947 0.292892 14.7071C0.105356 14.5196 -6.23549e-07 14.2653 -6.11956e-07 14C-6.00363e-07 13.7348 0.105356 13.4805 0.292892 13.2929C0.480428 13.1054 0.734783 13 0.999999 13L2.268 13C2.44354 12.696 2.69602 12.4436 3.00004 12.268C3.30407 12.0925 3.64894 12.0001 4 12.0001C4.35106 12.0001 4.69593 12.0925 4.99996 12.268C5.30398 12.4436 5.55646 12.696 5.732 13L13 13C13.2652 13 13.5196 13.1054 13.7071 13.2929C13.8946 13.4805 14 13.7348 14 14Z" fill="#2D3748" fillOpacity="0.8" />
                </svg>}
                variant='outline'
            />
            <MenuList boxShadow="0px 4px 32px 4px rgba(45, 55, 72, 0.05)" w={width} p={5} className="rounded-[15px]">
                {checkboxMarkup}
            </MenuList>
        </Menu>
    )
})

export default FilterPanel

const ParentCheckBox = ({ index, label, value, children, setFilter }: any) => {
    const [showChildren, setShowChildren] = useState(false)

    const onChange = (e: any) => {
        if (!e.target.checked) setFilter((state: any) => ({ ...state, [value]: [] }))
        setShowChildren(!showChildren)
    }

    return (
        <>
            <div className="flex justify-between">
                <Checkbox gap={1}
                    borderRadius="50%"
                    w={'100%'}
                    colorScheme="black"
                    isChecked={showChildren}
                    onChange={onChange}
                >

                    <div className="flex w-full justify-between">
                        {label}
                        {
                            showChildren ? <HiOutlineChevronUp /> : <HiOutlineChevronDown />
                        }
                    </div>

                </Checkbox>
            </div>

            {showChildren && children}
        </>

    )
}

const ChildCheckBox = ({ label, selection_mode, filter, value, setFilter, parent }: any) => {

    let selectedChildren = filter[parent] ? filter[parent] : []

    const onCheck = (isChecked: any, mode: any) => {
        if (selection_mode === 'single') {
            if (isChecked) setFilter((state: any) => ({ ...state, [parent]: [mode] }))
            else setFilter((state: any) => ({ ...state, [parent]: selectedChildren.filter((item: any) => item.value !== mode.value) }))
        }
        else {
            if (isChecked) setFilter((state: any) => ({ ...state, [parent]: [...selectedChildren, mode] }))
            else setFilter((state: any) => ({ ...state, [parent]: selectedChildren.filter((item: any) => item.value !== mode.value) }))
        }

    }


    return (

        <Checkbox size={'sm'} gap={1} colorScheme="black"
            fontSize={'md'} fontWeight={500}
            isChecked={selectedChildren.map((item: any) => (item.value)).includes(value)}
            onChange={(e) => onCheck(e.target.checked, { value, label })}
        >
            {label}
        </Checkbox>
    )
}

// const CustomMenuButton = forwardRef<BoxProps, 'div'>((props, ref) => {
//     const { filter }: any = props
//     let count: any = 0
//     Object.keys(filter).map((key: any) => {
//         if (_.isArray(filter[key]) && _.size(filter[key]) > 0) {
//             count = count + 1
//         }
//     })

//     return (<Box display={'flex'} gap={2} justifyContent={'center'} alignItems={'center'} _hover={{ cursor: 'pointer', backgroundColor: 'gray.300' }} border={'1px'} borderColor={'gray.200'} className={' !border-gray-100'} p={2} rounded='md' shadow='sm' ref={ref} {...props} >
//         <div>
//             <svg width="16" height="18" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
//                 <path d="M13 3.00003C13.2652 3.00003 13.5196 2.89468 13.7071 2.70714C13.8946 2.5196 14 2.26525 14 2.00003C14 1.73482 13.8946 1.48046 13.7071 1.29293C13.5196 1.10539 13.2652 1.00003 13 1.00003L5.732 1.00003C5.55646 0.696019 5.30398 0.443566 4.99996 0.268046C4.69593 0.0925252 4.35106 0.000121649 4 0.000121633C3.64894 0.000121618 3.30407 0.0925251 3.00004 0.268045C2.69602 0.443566 2.44354 0.696019 2.268 1.00003L1 1.00003C0.734783 1.00003 0.480429 1.10539 0.292892 1.29293C0.105356 1.48046 -7.5826e-08 1.73482 -8.74189e-08 2.00003C-9.90119e-08 2.26525 0.105356 2.5196 0.292892 2.70714C0.480429 2.89468 0.734783 3.00003 1 3.00003L2.268 3.00003C2.44354 3.30405 2.69602 3.5565 3.00004 3.73202C3.30407 3.90754 3.64894 3.99995 4 3.99995C4.35106 3.99995 4.69593 3.90754 4.99996 3.73202C5.30398 3.5565 5.55646 3.30405 5.732 3.00003L13 3.00003ZM13 9.00003C13.2652 9.00003 13.5196 8.89468 13.7071 8.70714C13.8946 8.5196 14 8.26525 14 8.00003C14 7.73482 13.8946 7.48046 13.7071 7.29293C13.5196 7.10539 13.2652 7.00003 13 7.00003L11.732 7.00003C11.5565 6.69602 11.304 6.44357 11 6.26805C10.6959 6.09253 10.3511 6.00012 10 6.00012C9.64894 6.00012 9.30407 6.09253 9.00004 6.26805C8.69602 6.44357 8.44354 6.69602 8.268 7.00003L1 7.00003C0.734783 7.00003 0.480428 7.10539 0.292892 7.29293C0.105356 7.48046 -3.38094e-07 7.73482 -3.49687e-07 8.00003C-3.6128e-07 8.26525 0.105356 8.5196 0.292892 8.70714C0.480428 8.89468 0.734783 9.00003 1 9.00003L8.268 9.00003C8.44354 9.30405 8.69602 9.5565 9.00004 9.73202C9.30407 9.90754 9.64894 9.99995 10 9.99995C10.3511 9.99995 10.6959 9.90754 11 9.73202C11.304 9.5565 11.5565 9.30405 11.732 9.00003L13 9.00003ZM14 14C14 14.2653 13.8946 14.5196 13.7071 14.7071C13.5196 14.8947 13.2652 15 13 15L5.732 15C5.55646 15.304 5.30398 15.5565 4.99996 15.732C4.69593 15.9075 4.35106 15.9999 4 15.9999C3.64894 15.9999 3.30407 15.9075 3.00004 15.732C2.69602 15.5565 2.44354 15.304 2.268 15L0.999999 15C0.734783 15 0.480428 14.8947 0.292892 14.7071C0.105356 14.5196 -6.23549e-07 14.2653 -6.11956e-07 14C-6.00363e-07 13.7348 0.105356 13.4805 0.292892 13.2929C0.480428 13.1054 0.734783 13 0.999999 13L2.268 13C2.44354 12.696 2.69602 12.4436 3.00004 12.268C3.30407 12.0925 3.64894 12.0001 4 12.0001C4.35106 12.0001 4.69593 12.0925 4.99996 12.268C5.30398 12.4436 5.55646 12.696 5.732 13L13 13C13.2652 13 13.5196 13.1054 13.7071 13.2929C13.8946 13.4805 14 13.7348 14 14Z" fill="#2D3748" fillOpacity="0.8" />
//             </svg>
//         </div>
//         {
//             count > 0 && <div className=" text-xs text-blue-500">
//                 {
//                     (count + ' Filter')
//                 }
//             </div>
//         }
//     </Box>)
// })